<div class="side-bar-view">

  <button class="button-row" color="accent" mat-raised-button (click)="clearMap()">Clear map</button>

  <button class="button-row" color="accent" mat-raised-button (click)="deleteLastDataPoint()">Undo</button>

  <button class="button-row" color="accent" mat-raised-button (click)="closeShape()">Close shape</button>

  <button class="button-row" color="accent" mat-raised-button (click)="toggleStyleOptions()">Style options</button>

  <app-polyline-style-options *ngIf="show" (styleViewCloseEvent)="closeStyleViewEvent($event)">
  </app-polyline-style-options>

  <p class="text-row"><b>Map center :</b> {{ mapCenter }}</p>

  <p class="text-row"><b>Zoom level :</b> {{ zoom }}</p>

  <p class="text-row"><b>Mouse cursor :</b> {{ mouseCursor }}</p>

  <cdk-virtual-scroll-viewport class="cdk-viewport" [itemSize]="20">
    <div *cdkVirtualFor="let item of observableData | async; let i = index; templateCacheSize: 0" class="item">
      {{item.lat}} , {{item.lng}}
    </div>
  </cdk-virtual-scroll-viewport>

  <p class="dev-info">Created by<a class="dev-info" href="https://github.com/sarweshkumar47"
    target="_blank">Sarweshkumar C R</a><span style="float:right;">Version 1.0.0</span></p>

</div>